import { OnsiteVisit } from '../shared/OnsiteVisit.js';

function OnsiteSiteVisitTable($interval, $location, $rootScope, onsiteService, filterService, twilioService) {
    return {
        redirect: 'E',
        replace: true,
        scope: {
            hideControls: "=?",
            hideSiteInfo: "=?",
            limit: "=?",
            showPagination: "=?",
            tableTitle: "=",
            visits: "="
        },
		template: require('./site-visit-table.html'),

        link: function (scope) {
            scope.displayOptions = filterService.getTableDisplayOptions(scope.tableTitle);
            scope.masterDisplayOptions = filterService.getMasterDisplayOptions();
            scope.activeVisitCount = 0;
            scope.currentPage = 0;
            scope.displayVisits = [];
            scope.sortedVisits = [];
            scope.fiveMinsAgo = moment().subtract(5, 'minutes').toDate();
            scope.hideSiteInfo = scope.hideSiteInfo || false;
            scope.limit = scope.limit || 25;
            scope.showPagination = scope.showPagination || false;
            scope.timerUpdate = $interval(updateNewCommentThreshold, 1000);
            scope.totalRows = scope.visits ? scope.visits.length : 0;
            scope.canWrite = $rootScope.selectedLog.role === "WRITE" || $rootScope.selectedLog.role === "ADMIN";


            function applyFilters(newValue) {

                if (!(newValue instanceof Array)) {
                    return;
                }

                var tempVisits = [].concat(newValue),
                    activeVisits = filterService.filterActiveOnly(tempVisits);

                tempVisits = scope.masterDisplayOptions.showActiveOnly || scope.displayOptions.showActiveOnly ? activeVisits : tempVisits;
                scope.activeVisitCount = tempVisits.length;
                scope.sortedVisits = filterService.sortVisits(scope.displayOptions.sortField, scope.displayOptions.sortDirection, tempVisits);
                scope.displayVisits = applyPagination(scope.sortedVisits);
            }

            function refreshFilters() {
                applyFilters(scope.visits)
            }

            function applyPagination(visits) {
                var availablePages = Math.ceil(visits.length / scope.limit);

                if (availablePages && scope.currentPage >= availablePages) {
                    scope.currentPage = (availablePages - 1);
                }

                var startIndex = (scope.currentPage) * scope.limit,
                    endIndex = startIndex + scope.limit;

                scope.totalRows = visits.length;

                return visits.slice(startIndex, endIndex);
            }

            function finalize() {
                $interval.cancel(scope.timerUpdate);
                scope.timerUpdate = null;
            }

            function updateNewCommentThreshold() {
                scope.fiveMinsAgo.setSeconds(scope.fiveMinsAgo.getSeconds() + 1);
            }

            scope.checkOutUser = function (visit) {
                onsiteService.checkOutContact(visit, $rootScope.user.id).then(function(retVisit){
                    twilioService.sendSMSText({
                        logId: visit.logId,
                        noteId: visit.noteId,
                        contactName: visit.userName,
                        toNumber: visit.phoneNumber,
                        message: "You have been checked out from " + visit.siteName ,
                        onsiteComment: false,
                        actionType: "checkOut"
                    });
                    
                    onsiteService.getVisit(visit.noteId).then(function(checkedOut){
                        scope.$emit('visit-removed', new OnsiteVisit(checkedOut));
                    });

                });
            };

            scope.onPageChange = function (pageIndex) {
                scope.currentPage = pageIndex;
                applyFilters(scope.visits);
            };

            scope.getRowClass = function (visit) {
                if (!visit.timeOut && visit.warningLevel === 2)
                    return 'danger';
                else if (!visit.timeOut && visit.warningLevel === 1)
                    return 'warning';
                else if (!visit.timeOut)
                    return 'success';
                else
                    return '';
            };

            scope.getDurationClass = function (visit) {
                if (visit.warningLevel === 2)
                    return ' danger ';
                else if (visit.warningLevel === 1)
                    return ' warning ';
                else
                    return '';
            };

            scope.showSmsModal = function (selectedVisit) {
                $rootScope.$broadcast('show-sms-modal', selectedVisit);
            };

            scope.toggleActiveOnly = function () {
                scope.displayOptions.showActiveOnly = !scope.displayOptions.showActiveOnly;
                filterService.setTableDisplayOptions(scope.tableTitle, scope.displayOptions);
                applyFilters(scope.visits);
            };

            scope.toggleComments = function () {
                scope.displayOptions.showComments = !scope.displayOptions.showComments;
                filterService.setTableDisplayOptions(scope.tableTitle, scope.displayOptions);
            };

            scope.undoCheckoutUser = function (visit) {
                onsiteService.undoCheckoutContact(visit, $rootScope.user.id).then(function(){

                    var sms = {
                        logId: visit.logId,
                        noteId: visit.noteId,
                        contactName: visit.userName,
                        toNumber: visit.phoneNumber,
                        message: "Your checkout from site '" + visit.siteName + "' has been removed." ,
                        onsiteComment: false,
                        actionType: "checkIn"
                    };
                    twilioService.sendSMSText(sms, function() {});
                    //$rootScope.$broadcast('refresh-requested');
                });
            };

            scope.goToNote = function(gotoUrl){
                $location.url(gotoUrl);
            };

            (function () {
                scope.$watch('visits', applyFilters, true);
                scope.$on('master-display-options-changed', refreshFilters);
                scope.$on('table-' + scope.tableTitle + '-display-options-changed', refreshFilters);
                scope.$on('$destroy', finalize);
            })();
        }
    }
}

angular.module('onsite').directive('onsiteSiteVisitTable', ['$interval', '$location', '$rootScope', 'onsiteService', "onsiteUiFilterService", "twilioService", OnsiteSiteVisitTable]);
